import {Drawer} from "antd";
import styled from "styled-components";

export const StyledSessionAvailabilityList = styled.div`
  padding: 8px;
  background-color: #fafafa;
  border: 1px solid #f0f0f0;
  max-width: 24rem;
  border-radius: 8px;
`;
export const StyledSessionAvailabilityListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.6rem;
`;
export const StyledSessionAvailabilityListItem = styled.div`
  display: flex;
  gap: 1.6rem;
`;
export const StyledSessionAvailabilityListDay = styled.p`
  max-width: 5rem;
  font-size: 1.4rem;
  font-weight: 600;
  width: 100%;
`;
export const StyledSessionAvailabilityListDayValue = styled.p`
  font-size: 1.4rem;
  font-weight: 400;
`;
export const StyledSessionAvailabilityListDrawer = styled(Drawer)`
  @media (max-width: 768px) {
    .ant-drawer-content-wrapper {
      width: 100% !important;
    }
  }
`;
export const StyledSessionAvailabilityListDrawerInfoBlock = styled.div`
  background-color: #fafafa;
  border: 1px solid #f0f0f0;
  padding: 1.6rem;
`;
export const StyledSessionAvailabilityListDrawerInfoBlockScheduleName = styled.div`
  font-weight: 600;
  font-size: 1.6rem;
`;
